import React from "react"

import { Home, XCircle } from "lucide-react"
import { Link } from "react-router-dom"

import AppLayout from "@/components/layout/AppLayout"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card"
import { SUPPORT_EMAIL } from "@/constants/contact"
import { useApplication } from "@/contexts/ApplicationContext"

const ApplicationRejectedPage = () => {
  const { application } = useApplication()
  return (
    <AppLayout>
      <div className="container mx-auto max-w-lg px-4 py-6">
        <Card>
          <CardHeader className="text-center">
            <div className="mb-4 flex justify-center">
              <div className="rounded-full bg-red-100 p-3">
                <XCircle className="h-8 w-8 text-red-600" />
              </div>
            </div>
            <CardTitle className="text-xl font-bold text-jungle">Application Rejected</CardTitle>
          </CardHeader>

          <CardContent className="space-y-4">
            <div className="rounded-lg border border-red-200 bg-red-50 p-4">
              <p className="mb-2 font-medium text-red-800">
                Your application was not successful: {application?.stageNote}
              </p>
              <p className="text-sm text-red-700">
                Unfortunately, we are unable to proceed with your application at this time. Thank
                you for your interest.
              </p>
            </div>

            <div className="space-y-3">
              <h3 className="font-medium text-gray-900">What happens next?</h3>
              <ul className="space-y-2 text-sm text-gray-600">
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  You can reapply in 1 month
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  Review our requirements for future applications
                </li>
                <li className="flex items-start">
                  <span className="mr-3 mt-1.5 inline-block h-2 w-2 flex-shrink-0 rounded-full bg-red-500"></span>
                  Consider gaining additional experience
                </li>
              </ul>
            </div>

            <div className="rounded-lg bg-gray-50 p-4">
              <p className="text-sm text-gray-600">
                If you have questions about your application, please contact us at{" "}
                <a href={`mailto:${SUPPORT_EMAIL}`} className="text-honeycomb hover:underline">
                  {SUPPORT_EMAIL}
                </a>
              </p>
            </div>
          </CardContent>

          <div className="space-y-3 p-6 pt-0">
            <Link to="/" className="block w-full">
              <Button className="w-full bg-honeycomb hover:bg-amber-500">
                <Home className="mr-2 h-4 w-4" /> Return to Home
              </Button>
            </Link>
          </div>
        </Card>
      </div>
    </AppLayout>
  )
}
export default ApplicationRejectedPage
